var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CourierForm',{attrs:{"courier":_vm.courier,"buttonLoading":_vm.buttonLoading},on:{"saveCourier":_vm.saveCourier}})}
var staticRenderFns = []

export { render, staticRenderFns }